import React from 'react';
import ConnectAsProvider from 'contexts/connect_as/provider';
import ConnectedAsBanner from 'components/ui/connected_as_banner';
import ConfirmRegistrationEmailBanner from 'components/session/confirm_registration_email_banner';
import { useSession } from 'hooks/use_context';
import Loader from 'components/ui/loader';
import lazyWithRetry from 'services/lazy_with_retry';
import EnvironmentBanner from 'components/ui/environment_banner';
import { LockProvider } from 'contexts/lock_ressource/provider';
const SharedContainer = lazyWithRetry(() => import('apps/shared/container'));
const ApplicationRouter = lazyWithRetry(() => import('apps/main/router'));

const ApplicationContainer = () => {
  const { currentUser } = useSession();
  return (
    <div data-cy="insurgate_application">
      <ConfirmRegistrationEmailBanner>
        <EnvironmentBanner />
        <ConnectAsProvider>
          <ConnectedAsBanner>
            <div className="main-app-container app-content-container">
              <LockProvider>
                <React.Suspense fallback={<Loader />}>{currentUser ? <SharedContainer /> : <ApplicationRouter />}</React.Suspense>
              </LockProvider>
            </div>
          </ConnectedAsBanner>
        </ConnectAsProvider>
      </ConfirmRegistrationEmailBanner>
    </div>
  );
};

export default ApplicationContainer;
